import pathEq from 'ramda/es/pathEq';
import path from 'ramda/es/path';

import { TARIFF_MONTHLY, TARIFF_BUNDLE } from 'app/common/constants/tariffs';


export const isSmsSubscribeActive = path([
  'tariff',
  'month_daily_params',
  'sms_subscribe_enabled',
]);

export const isMonthly = pathEq([
  'tariff',
  'kind',
], TARIFF_MONTHLY);

export const isBundle = pathEq([
  'tariff',
  'kind',
], TARIFF_BUNDLE);
